import GeckoFeatures from '../services/gecko-features';
import GeckoStore from "../services/gecko-store";

export const isSupportOrFeatureToggledOn = (
  toggleName
) => {
  return (
    GeckoStore.redux.get('appState.isSupport') ||
    GeckoFeatures.can(toggleName)
  );
};

